module.exports = __webpack_public_path__ + "static/Logo50-90bf09fdfbacf394a0615c47ab364231.svg";